import React, { Component } from 'react';
import { css } from 'glamor';
import Helmet from 'react-helmet';
import Happy from 'react-icons/lib/io/android-happy';
import { Link } from 'react-router-dom';

import Animated from '../components/Animated';
import Image from '../components/Image';
import Video from '../components/Video';

import {
  textContainer,
  center,
  wideContainer,
  removePaddingVertical,
  shadowless,
  fillButton,
  nowrap,
} from '../styles';

class ImmersiveScholar extends Component {
  constructor(props) {
    super(props);

    const headerImage = this.getImage(
      'immersive-scholar-residency-at-ncsu',
      'hunt-library-ncsu-16x9',
      1
    );

    const videoImage = this.getImage(
      'community-gardens',
      'community-gardens-video',
      1
    );

    this.state = { headerImage, videoImage };
  }

  getImage = (folder, filename, r) => {
    return [
      {
        srcSet: require(`../assets/${folder}/${filename}-thumb-${r}.jpg`),
        media: '(max-width: 100px)',
      },
      {
        srcSet: require(`../assets/${folder}/${filename}-sm-${r}.jpg`),
        media: '(max-width: 720px)',
      },
      {
        srcSet: require(`../assets/${folder}/${filename}-${r}.jpg`),
      },
    ];
  };
  componentWillMount() {
    this.props.loadTheme();
  }

  render() {
    const { theme } = this.props;
    const { headerImage, videoImage } = this.state;
    return (
      <div>
        <Helmet
          title="Immersive Scholar Residency with North Carolina State University"
          description="Lucas Swick was awarded a 6-week residency with NCSU funded by the Mellon
          Foundation."
        />
        <Image ratio="16x9" sources={headerImage} />
        <div {...textContainer}>
          <Animated as="h1">Immersive Scholar Residency</Animated>
          <Animated>
            I was recently awarded a{' '}
            <a
              href="https://www.immersivescholar.org/residents"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              6-week residency
            </a>{' '}
            with North Carolina Statue University, funded by the{' '}
            <a
              href="https://mellon.org/"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              Andrew W. Mellon Foundation
            </a>{' '}
            .
          </Animated>
          <Animated as="h2">Background</Animated>
          <Animated>
            NCSU recently built the{' '}
            <a
              target="_blank"
              rel="nofollow noopener noreferrer"
              href="https://www.lib.ncsu.edu/huntlibrary"
            >
              library of the future
            </a>. It includes a book-fetching robot, community spaces for
            learning, and all kinds of amazing technologies for students to play
            with.
          </Animated>
          <Animated>
            Included in the spaces are giant{' '}
            <a
              target="_blank"
              rel="nofollow noopener noreferrer"
              href="https://www.christiedigital.com/en-us/business/products/microtiles"
            >
              Microtile
            </a>{' '}
            (DLP + LED) walls that I'll be making content for.
          </Animated>
          <Animated as="h2">Objective</Animated>
          <Animated>
            I will develop 3-5 generative art concepts inspired by nature and
            related to the story of deep importance to the local NCSU/Raleigh
            community - food and housing (in)security for students.
          </Animated>
          <Animated>
            Each concept will use data as inputs, in consultation with NCSU's
            Dr. Mary Haskett, that affect the visualization, generating an
            endless series of slowly evolving visuals.
          </Animated>
          <Animated as="h2">Visuals</Animated>
          <Animated>
            The visuals will be inspired by botanical artists to create a
            generative garden. It will be created in 3D and the audience will be
            taken on a meandering path. Depending on the inputs fed to the
            installation, the garden will either be more or less healthy.
          </Animated>
          <Animated>
            Users will be able to connect to the installation on their mobile
            devices to interact with the installation.
          </Animated>
          <Animated as="h2">Results</Animated>
        </div>
        <div {...wideContainer} {...removePaddingVertical}>
          <Video videoId={'313697626'} sources={videoImage} />
        </div>
        <div {...textContainer}>
          <Animated>
            The installation is now up and running! Read the{' '}
            <Link
              {...shadowless}
              to="/work/community-gardens-a-data-driven-generative-art-installation-about-housing-insecurity-at-ncsu"
            >
              Community Gardens Case Study
            </Link>{' '}
            for more information, or view a mini-version of the installation in
            your browser:{' '}
            <a
              href="https://communitygardens.generativeartist.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              Community Gardens
            </a>.{' '}
          </Animated>
          <div {...center} {...css({ margin: '3rem 0' })}>
            <Animated>
              <a
                {...nowrap}
                {...fillButton}
                {...shadowless}
                {...css(
                  theme &&
                    theme.colors && {
                      color: theme.colors[0],
                      background: theme.colors[1],
                      transition: 'all 0.2s',
                    }
                )}
                {...css(
                  theme &&
                    theme.colors && {
                      '&:hover': {
                        textDecoration: 'none',
                        color: '#333',
                        background: theme.colors[2],
                      },
                    }
                )}
                href="https://communitygardens.generativeartist.com/"
                target="_blank"
                rel="nofollow noopener noreferrer"
              >
                Visit Community Gardens
              </a>{' '}
            </Animated>
          </div>

          <div {...center}>
            <Animated as="div">
              <Happy color="#F772D7" size={90} />
            </Animated>
          </div>
        </div>
      </div>
    );
  }
}

export default ImmersiveScholar;



// WEBPACK FOOTER //
// ./src/pages/ImmersiveScholar.js